export enum MatchType {
    Fixture,
    Result,
    Trends,
}
